export default __webpack_public_path__ + "static/media/thumbs-challenge.64153e30.svg";